export default __webpack_public_path__ + "static/media/January_00.e7b3ca71.png";